<template>
  <div>
    <v-container style="position: absolute;">
      <v-row style="float: right;">
        <v-btn @click.stop="index_nav = !index_nav" rounded color="blue" dark fab style="z-index: +5">
          <v-icon>mdi-36px mdi-pan</v-icon>
        </v-btn>
      </v-row>
    </v-container>
    <v-navigation-drawer
      v-model="index_nav"
      absolute
      temporary
      dark
      dense
      src="@/assets/moonlight.jpg">
      <template v-slot:prepend>
        <v-list>
          <v-list-item>
            <v-list-item-avatar>
              <v-img>Img</v-img>
            </v-list-item-avatar>
            <v-spacer></v-spacer>
            <v-btn rounded color="indigo" dark @click="signout()">{{ $t('navigation_logout') }}</v-btn>
          </v-list-item>

          <v-list-item
            link
            two-line
          >
            <v-list-item-content>
              <v-list-item-title class="title white--text">{{ user.name }}</v-list-item-title>
              <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon>mdi-menu-down</v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </template>
      <v-list
        nav
        dense> 
        <router-link to="/dashboard/home">
          <v-list-item link>
            <v-list-item-icon>
              <v-icon>mdi-home</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ $t('navigation_dashboard') }}</v-list-item-title>
          </v-list-item> 
        </router-link>
        <router-link to="/dashboard/profile">
        <v-list-item link>
          <v-list-item-icon>
            <v-icon>mdi-account-multiple</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t('dashboard_profile') }}</v-list-item-title>
        </v-list-item>
        </router-link>
        <router-link to="/dashboard/qrcode">
          <v-list-item link>
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ $t('dashboard_qrcode') }}</v-list-item-title>
          </v-list-item>
        </router-link>
        <router-link to="/dashboard/notifications">
          <v-list-item link>
            <v-list-item-icon>
              <v-icon>mdi-star</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ $t('dashboard_notification') }}</v-list-item-title>
          </v-list-item>
        </router-link>
        <router-link to="/dashboard/payment">
          <v-list-item link>
            <v-list-item-icon>
              <v-icon>mdi-folder</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ $t('dashboard_pay') }}</v-list-item-title>
          </v-list-item>
        </router-link>
        <router-link to="/dashboard/transactions">
          <v-list-item link>
            <v-list-item-icon>
              <v-icon>mdi-account-multiple</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ $t('dashboard_log') }}</v-list-item-title>
          </v-list-item>
        </router-link>
        <router-link to="/dashboard/settings">
          <v-list-item link>
            <v-list-item-icon>
              <v-icon>mdi-star</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ $t('dashboard_set') }}</v-list-item-title>
          </v-list-item>
        </router-link>
        <router-link to="/dashboard/issues">
          <v-list-item link>
            <v-list-item-icon>
              <v-icon>mdi-star</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ $t('dashboard_issue') }}</v-list-item-title>
          </v-list-item>
        </router-link>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
  import {fb, db} from '@/firebase';

  export default {
    data: () => ({
      index_nav: false
    }),
    methods: {
      signout() {
        fb.auth().signOut()
        .then(() => {
          this.$router.replace('/')
        })
        .catch((err) => {
          /* eslint-disable no-console */
          console.log(err);
          /* eslint-enable no-console */
        })
      }
    },

    created () {
      db.collection('user').where('user_id','==',fb.auth().currentUser.uid).get()
      .then(snapshot=>{
        snapshot.forEach(doc => {
          this.user =doc.data()
          this.user.id = doc.id
        })
      })
    }
  }
</script>